import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/CookieBanner.module.css";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("britosa_cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("britosa_cookie_consent", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-label="Aviso de cookies">
      <div className={styles.content}>
        <p>
          Utilizamos cookies propias y de terceros para mejorar tu experiencia, analizar el tráfico y personalizar contenido.
          Al continuar navegando, aceptas su uso. Puedes consultar nuestra{" "}
          <Link to="/politica-privacidad">Política de Privacidad</Link>.
        </p>
        <button onClick={accept} className={styles.btn}>Aceptar</button>
      </div>
    </div>
  );
}
